
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 .667a2 2 0 0 0-2 2V4q0 .12.014.237A.3.3 0 0 0 0 4.333v2.942c0 .285.334.439.55.253l1.222-1.046A2 2 0 0 1 3.073 6H6a2 2 0 0 0 2-2V2.667a2 2 0 0 0-2-2z","fill":"#fff"}})])
          )
        }
      }
    